import { writable } from 'svelte/store';
import { browserSupportsWebgl } from '../../util/supportswebgl.js';
import { userPrefersReducedMotion } from '@pin/dom-utils';

export const showWebGlAnimations = writable<boolean>(
  userPrefersReducedMotion() === false && browserSupportsWebgl() === true
);
